import { create } from 'zustand';

// Story 65.19 — pedido de abertura do "Receber em partes". O compositor é desenhado num ponto
// único do casco do app (ReceiptComposerHost), para não depender da tela que o abriu.

export type ReceiptComposerOutcome = 'confirmed' | 'dismissed';

export interface ReceiptComposerRequest {
  ids: string[];
  onFinished?: (outcome: ReceiptComposerOutcome) => void;
}

interface ReceiptComposerHostState {
  request: ReceiptComposerRequest | null;
  open: (request: ReceiptComposerRequest) => void;
  close: () => void;
}

export const useReceiptComposerHost = create<ReceiptComposerHostState>((set) => ({
  request: null,
  open: (request) => set({ request }),
  close: () => set({ request: null }),
}));
